<template>
  <div class="equipmentPatrolWrap mainPageBg">
    <div class="sheetsContent commonOrderContent">
      <div class="formBox">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="">
            <el-input v-model="formInline.searchTxt" placeholder="请输入内容">
              <el-select v-model="formInline.select" slot="prepend">
                <el-option label="巡检人" value="1"></el-option>
                <el-option label="巡检编码" value="2"></el-option>
                <el-option label="巡检内容" value="3"></el-option> </el-select
            ></el-input>
          </el-form-item>
          <el-form-item label="时间范围">
            <el-date-picker
              v-model="formInline.timeData"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              unlink-panels
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button
              type="warning"
              icon="el-icon-plus"
              @click="
                dialogVisible = true;
                title = '新增巡检计划';
              "
              >新增巡检计划</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <div class="tabCardBox">
        <el-tabs type="border-card" style="height: 100%" v-model="selectTab">
          <el-tab-pane
            :label="v"
            v-for="(v, i) in cardList"
            :key="i"
            style="height: 100%"
          >
            <div class="orderCardItem">
              <el-table
                :data="tableData"
                stripe
                border
                style="width: 100%"
                class="tabWrap"
                height="90%"
                :header-cell-style="{
                  'background-color': '#F7F7F7',
                }"
                :cell-style="cellStyle"
                @cell-click="cellClick"
              >
                <el-table-column
                  v-for="(v, i) in tabHead"
                  :key="i"
                  :prop="v.prop"
                  :label="v.label"
                  align="center"
                ></el-table-column>
                <el-table-column label="操作" width="200" align="center">
                  <template slot-scope="scope">
                    <template v-if="scope.row.state !== '已完成'">
                      <template v-if="scope.row.state !== '正在巡检'">
                        <el-button type="text" size="small">分配人员</el-button>
                        <el-button
                          type="text"
                          size="small"
                          @click="deleteOrder(scope.row)"
                          >删除计划</el-button
                        >
                        <el-button
                          type="text"
                          size="small"
                          @click="
                            dialogVisible = true;
                            title = '编辑巡检计划';
                          "
                          >编辑计划</el-button
                        >
                      </template>
                      <el-button
                        v-else
                        type="text"
                        size="small"
                        @click="completeOrder(scope.row)"
                        >分配人员</el-button
                      >
                    </template>
                    <div v-else>-</div>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 30, 50, 100]"
                :page-size="10"
                layout="total, sizes, prev, pager, next, jumper"
                :total="200"
                style="margin-top: 10px; text-align: right"
              >
              </el-pagination>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <!-- 巡检详情 -->
    <el-drawer
      :visible.sync="patrolDetails"
      :with-header="false"
      class="drawerWrap"
      size="45%"
    >
      <PatrolDetails />
    </el-drawer>
  </div>
</template>

<script>
import PatrolDetails from "@/components/houqinguanli/shebeixunjian/PatrolDetails";
export default {
  components: {
    PatrolDetails,
  },
  data() {
    return {
      titile: "",
      formInline: {
        searchTxt: "",
        select: "1",
        timeData: [],
      },
      dialogVisible: false,
      patrolDetails: false,
      selectTab: "",
      cardList: ["全部", "未巡检", "正在巡检", "已完成"],
      tabHead: [
        { label: "创建时间", prop: "time" },
        { label: "巡检编码", prop: "num" },
        { label: "巡检内容", prop: "event" },
        { label: "巡检计划", prop: "address" },
        { label: "巡检开始时间", prop: "startTime" },
        { label: "巡检状态", prop: "state" },
        { label: "巡检人", prop: "user" },
        { label: "备注", prop: "remarks" },
      ],
      tableData: [
        {
          time: "2022-02-01 12:00:00",
          num: "1234324",
          event: "用能设备一层大楼照明设备发生危险告警",
          address: "照明系统巡检",
          startTime: "",
          state: "待巡检",
          user: "",
          remarks: "",
        },
        {
          time: "2022-02-01 12:00:00",
          num: "1234324",
          event: "用能设备一层大楼照明设备发生危险告警",
          address: "照明系统巡检",
          startTime: "2022-02-01 17:00:00",
          state: "正在巡检",
          user: "张三",
          remarks: "",
        },
        {
          time: "2022-02-01 12:00:00",
          num: "1234324",
          event: "用能设备一层大楼照明设备发生危险告警",
          address: "照明系统巡检",
          startTime: "2022-02-01 17:00:00",
          state: "已完成",
          user: "张三",
          remarks: "备注内容",
        },
      ],
      currentPage: 1,
    };
  },
  methods: {
    onSubmit() {},
    cellStyle(row) {
      if (row.column.label === "巡检状态") {
        switch (row.row.state) {
          case "待巡检":
            return "color:#E31313";
            break;
          case "正在巡检":
            return "color:#FF6600";
            break;
          case "已完成":
            return "color:#66b1ff";
            break;
          default:
            return "";
            break;
        }
      }
      if (row.column.label === "巡检编码") {
        return "color:#66b1ff;cursor: pointer";
      }
      if (
        row.column.label === "创建时间" ||
        row.column.label === "巡检开始时间"
      ) {
        return "font-size:12px";
      }
    },
    cellClick(row, column) {
      if (column.label == "巡检编码") {
        this.patrolDetails = true;
      }
    },
    deleteOrder(row) {
      this.$confirm("此操作将永久删除该巡检计划, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {})
        .catch(() => {});
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.equipmentPatrolWrap {
  @include setFlexCenter;
  .sheetsContent {
    width: 98%;
    height: 96%;
    ::v-deep .el-select .el-input {
      width: 120px;
    }
    ::v-deep .el-tabs__content {
      height: calc(100% - 50px);
    }
  }
}
</style>